export const TEMPLATE_SAVE_DATA = 'ACTION_SLOTMANAGEMENT_TEMPLATE_SAVE_DATA';
export const TEMPLATE_FETCH_DATA = 'ACTION_SLOTMANAGEMENT_TEMPLATE_FETCH';
export const TEMPLATE_FETCH_DATA_CALENDAR = 'TEMPLATE_FETCH_DATA_CALENDAR';
export const TEMPLATE_EDIT_SLOT = 'ACTION_SLOTMANAGEMENT_TEMPLATES_EDIT_SLOT';
export const TEMPLATE_DEL_SLOT_SELECTED = 'TEMPLATE_DEL_SLOT_SELECTED';
